<template>
    <div class="carousel">
        <div class="text-center mt-4">
            <a href="#" class="prev-slide">Anterior</a> |
            <a href="#" class="next-slide">Próximo</a>
        </div>
        <dd-carousel-navigation :max="images.length" :min="1" @goTo="goToImage"></dd-carousel-navigation>
        <swiper :options="swiperOption" ref="slider">
            <swiper-slide
                class="swiper-slide swiper-lazy"
                v-for="image in images"
                :key="image"
                :data-background="image"
            >
                <div class="h-full w-full cursor-pointer" @click="openInNewTab(image)"></div>
                <div class="swiper-lazy-preloader"></div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
    </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import DdCarouselNavigation from "./carousel/DdCarouselNavigation";

export default {
    props: {
        images: {
            type: Array,
            default: () => []
        },
        startImageAt: {
            type: Number,
            default: 0
        }
    },
    components: {
        swiper,
        swiperSlide,
        DdCarouselNavigation
    },
    mounted() {
        this.$refs.slider.swiper.slideTo(this.startImageAt);
    },
    data() {
        return {
            swiperOption: {
                navigation: {
                    nextEl: ".next-slide",
                    prevEl: ".prev-slide"
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    type: "custom",
                    renderCustom: function(swiper, current, total) {
                        return `<span class="swiper-pagination-current">${current}</span> de <span class="swiper-pagination-total">${total}</span> imagens`;
                    }
                },
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 1
                },
                on: {
                    slideChangeTransitionEnd: () => {
                        this.$emit(
                            "currentSlideIndex",
                            this.$refs.slider.swiper.activeIndex
                        );
                    }
                }
            }
        };
    },
    methods: {
        openInNewTab(image) {
            window.open(image, "_blank");
        },
        goToImage(index) {
            this.$refs.slider.swiper.slideTo(index);
        }
    }
};
</script>

<style>
.carousel .swiper-slide {
    background-position: center top;
    background-repeat: no-repeat;
    background-size: contain;
    height: 900px;
    object-fit: cover;
}

.carousel .swiper-pagination-bullet {
    background: #7367f0;
    width: 50px;
    border-radius: 0;
    height: 3px;
}

.carousel .swiper-container .swiper-slide {
    background-color: #eee;
}
</style>
